import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'paybylink_validation';
export const route = 'paybylink/[membershipId]';
export const PayByLinkMembershipValidationPage = createPage(page, /*#__PURE__*/lazy(() => import(/* webpackChunkName: "paybylink_validation" */
/* webpackPrefetch: true */
'../../components/Prime/PayByLink/PayByLinkMembershipValidationPage')));